var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentWorkCircles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1608,
    height: 745
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M0 0h1608v745H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-448 -2396)",
    opacity: 0.072,
    fill: "rgba(232,233,234,0.74)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(224)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1600 2400)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1600 2724)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1600 2940)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1488 2400)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1488 2508)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1488 2616)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1488 2724)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1488 2832)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1488 3048)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1376 2400)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1376 2508)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1376 2616)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1376 2724)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1376 2832)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1376 3048)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1264 2400)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1264 2616)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1264 2724)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1264 2832)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1264 2940)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1264 3048)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1152 2400)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1152 2508)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1152 2616)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1152 2724)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1152 2832)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1152 2940)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1152 3048)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1040 2508)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1040 2616)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1040 2724)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1040 2832)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1040 2940)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1040 3048)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(928 2400)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(928 2508)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(928 2616)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(928 2724)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(928 2832)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(928 2940)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(816 2400)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(816 2508)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(816 2616)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(816 2724)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(816 2832)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(816 2940)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(816 3048)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(704 2400)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(704 2508)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(704 2616)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(704 2724)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(704 2832)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(704 3048)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(592 3048)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(592 2940)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(592 2832)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(592 2616)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(592 2508)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(592 3048)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(592 2940)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(592 2508)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(592 3048)"
  }))));
}
export default "/_next/static/assets/public/graphics/studentWork/eeb217f450f991066e16dbd77c430be8.svg";
export { SvgStudentWorkCircles as ReactComponent };